export default "__VITE_ASSET__DTyqBq$i__"